import { existsSync } from 'node:fs';
import { join } from 'node:path';

export const VALID_PATH_REGEX = /^[a-z0-9\-/]+$/;

const VALID_UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

export function pathValidation(path: string): boolean {
  return VALID_PATH_REGEX.test(path);
}

export function pathAvailableValidation(path: string) {
  return function (folder: string) {
    return !existsSync(join(path, folder));
  };
}

export function folderExistsMessage(
  kind: string,
  folder: string,
  sourceField: 'title' | 'name'
): string {
  return `The ${kind} folder '${folder}' already exists. Choose a different ${sourceField}, or pass a unique 'folder' explicitly.`;
}

export function uuidValidation(id: string): boolean {
  return VALID_UUID_REGEX.test(id);
}

type ValidationResult = { valid: true } | { valid: false; reason: string };

export function composeValidations<T>(
  validations: Array<[(value: T) => boolean, reason: string]>
): (value: T) => ValidationResult {
  return (value) => {
    for (const [validation, reason] of validations) {
      if (!validation(value)) {
        return { valid: false, reason };
      }
    }
    return { valid: true };
  };
}

export function useValidation<T>(fn: (value: T) => ValidationResult) {
  return (value: T): true | string => {
    const result = fn(value);
    return result.valid || result.reason;
  };
}
